import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsChecklist = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <rect
          x="6.1542339"
          y="3.0965824"
          width="16.716053"
          height="0.9087719"
        />
        <rect
          x="6.3395019"
          y="11.5570259"
          width="16.716053"
          height="0.9088219"
        />
        <rect
          x="6.1542339"
          y="19.9738979"
          width="16.716053"
          height="0.9087719"
        />
        <path
          d="M1.9646895,5.0875158c0.84289,0.3491244,1.8093085-0.0511584,2.1584833-0.8940983
		c0.3491244-0.84289-0.0511584-1.8093088-0.8940485-2.158483c-0.8429399-0.3491247-1.8093586,0.0511582-2.158483,0.8940482
		C0.7214667,3.7719226,1.1217495,4.7383413,1.9646895,5.0875158z"
        />
        <path
          d="M2.2182851,10.4150715c-0.8879591,0.2096748-1.4377742,1.0994301-1.2280998,1.98734
		c0.2096244,0.8879089,1.0993805,1.4377241,1.9873397,1.2280998c0.8879094-0.2096748,1.4377244-1.0994301,1.2281001-1.98734
		C3.9959505,10.7552118,3.1061945,10.2053976,2.2182851,10.4150715z"
        />
        <path
          d="M2.8616824,18.8082848c-0.9005865-0.1461372-1.7491663,0.4654675-1.8953044,1.3660526
		c-0.1461881,0.9005871,0.4654163,1.7491665,1.3660028,1.8953056c0.9005866,0.1461868,1.7491665-0.465416,1.8953047-1.366003
		C4.3738732,19.8030529,3.762269,18.9544735,2.8616824,18.8082848z"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsChecklist;
